import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
import { store } from '../store/store';

export default class MapLoader {
    constructor() {
        this.mapContainer = document.getElementById('google-map');
        if (this.mapContainer && store.gApi) {
            this.locationData = this.mapContainer.dataset.mapInfo;
            if (this.locationData) {
                this.events();
            }
        }
    }

    mapPosition() {
        try {
            this.parsedData = JSON.parse(this.locationData);
        } catch (e) {
            console.error('Invalid map data JSON:', e);
            return false;
        }

        this.lat = this.parsedData.lat;
        this.lng = this.parsedData.lng;
        this.postionMap = {
            lat: this.lat,
            lng: this.lng,
        };
        this.markerCenter = {
            lat: this.lat,
            lng: this.lng,
        };
        return true;
    }

    loaderInit() {
        setOptions({ key: store.gApi });
    }

    markers() {
        this.marker = new this.AdvancedMarkerElement({
            position: this.postionMap,
            map: this.map,
        });
    }

    async events() {
        if (!this.mapPosition()) return;

        this.loaderInit();

        const [{ Map }, { AdvancedMarkerElement }, { ControlPosition }] =
            await Promise.all([
                importLibrary('maps'),
                importLibrary('marker'),
                importLibrary('core'),
            ]);

        this.ControlPosition = ControlPosition;
        this.AdvancedMarkerElement = AdvancedMarkerElement;

        this.map = new Map(this.mapContainer, {
            center: this.markerCenter,
            zoom: 11.85,
            disableDefaultUI: true,
            mapId: store.gMapId,
        });

        this.initPlaceCard(this.map);
        this.markers();
    }

    initPlaceCard(map) {
        const data = this.parsedData;

        // Build DOM elements safely to prevent XSS
        this.div = document.createElement('div');
        this.div.classList.add('placeCard');

        const placeCard = document.createElement('div');
        placeCard.className = 'place-card';

        const wrap = document.createElement('div');
        wrap.className = 'place-card__wrap';

        // Details and navigation wrapper
        const detailsNavWrap = document.createElement('div');
        detailsNavWrap.className = 'place-card__details-navigation-wrap';

        // Details section
        const details = document.createElement('div');
        details.className = 'place-card__details details';

        const nameEl = document.createElement('div');
        nameEl.className = 'details__name';
        nameEl.textContent = data.name;

        const addressEl = document.createElement('div');
        addressEl.className = 'details__address';
        addressEl.textContent = `${data.street_name} ${data.street_number}, ${data.post_code} ${data.city}, ${data.country}`;

        details.appendChild(nameEl);
        details.appendChild(addressEl);

        // Navigation section
        const navigate = document.createElement('div');
        navigate.className = 'place-card__navigate navigate';

        const navInner = document.createElement('div');
        navInner.className = 'navigate';

        const navLink = document.createElement('a');
        navLink.className = 'navigate__link';
        navLink.href = `https://maps.google.com/maps?ll=${encodeURIComponent(data.lat)},${encodeURIComponent(data.lng)}&z=16&t=m&hl=pl-PL&gl=PT&mapclient=embed&daddr=${encodeURIComponent(data.address)}@${encodeURIComponent(data.lat)},${encodeURIComponent(data.lng)}`;
        navLink.target = '_blank';

        const navIcon = document.createElement('div');
        navIcon.className = 'icon navigate__icon';

        const navText = document.createElement('div');
        navText.className = 'navigate__text';
        navText.textContent = 'Wskazówki dojazdu';

        navLink.appendChild(navIcon);
        navLink.appendChild(navText);
        navInner.appendChild(navLink);
        navigate.appendChild(navInner);

        detailsNavWrap.appendChild(details);
        detailsNavWrap.appendChild(navigate);

        // Larger map section
        const largerMap = document.createElement('div');
        largerMap.className = 'place-card__larger-map larger-map';

        const largerMapLink = document.createElement('a');
        largerMapLink.className = 'larger-map__google-maps-link';
        largerMapLink.href = `https://www.google.com/maps/place/${encodeURIComponent(data.name)}/@${encodeURIComponent(data.lat)},${encodeURIComponent(data.lng)},17z/data=!3m1!4b1!4m5!3m4!1s0x471ecb855d26d6f9:0xd5da3dfd2d11c3b5!8m2!3d${encodeURIComponent(data.lat)}!4d${encodeURIComponent(data.lng)}?hl=pl-PL`;
        largerMapLink.target = '_blank';
        largerMapLink.textContent = 'Wyświetl większą mapę';

        largerMap.appendChild(largerMapLink);

        wrap.appendChild(detailsNavWrap);
        wrap.appendChild(largerMap);
        placeCard.appendChild(wrap);
        this.div.appendChild(placeCard);

        map.controls[this.ControlPosition.BLOCK_START_INLINE_END].push(
            this.div,
        );
    }
}
